export const MAX_IMAGE_WIDTH = 1280;//todo:cambiare con le dimensioni reali
export const MAX_IMAGE_HEIGHT = 1280;